module.exports = __webpack_public_path__ + "b73496650fd4827b24d7f77e255e0c41.svg";